import { useContext } from 'react';
import { SimpleDialogContext } from '../context/SimpleDialogContext';

export function useSimpleDialog() {
  return useContext(SimpleDialogContext);
}
